<template>
  <v-card
    flat
    style="width: 100%; background: #f8f9fb;"
    class="d-flex justify-center align-center flex-column"
  >
    <v-card-text style="width: 1000px; background: white;">
      <v-row justify="center" align="center">
        <v-col cols="12" class="py-5">
          <h2>
            {{ $i18n.t("personal.Please improve your personal information") }}
          </h2>
        </v-col>
        <v-col sm="12" md="6">
          <div class="common-font-black-bold mb-2">
            {{ $i18n.t("personal.full_name") }}*
          </div>
          <label>
            <input v-model.trim="userInformation.name" type="text" />
          </label>
        </v-col>
        <v-col md="6" sm="12">
          <div class="common-font-black-bold mb-2">
            {{ $i18n.t("personal.telephone") }}*
          </div>
          <label>
            <input v-model.trim="userInformation.telephone" type="text" />
          </label>
        </v-col>
        <v-col md="6" sm="12">
          <div class="common-font-black-bold mb-2">
            {{ $i18n.t("personal.company") }}*
          </div>
          <label>
            <input v-model.trim="userInformation.company" type="text" />
          </label>
        </v-col>
        <v-col md="6" sm="12">
          <div class="common-font-black-bold mb-2">
            {{ $i18n.t("personal.title") }}
          </div>
          <label>
            <input v-model.trim="userInformation.jobTitle" type="text" />
          </label>
        </v-col>
        <v-col cols="12">
          <div class="common-font-black-bold mb-2">
            {{ $i18n.t("personal.address") }}
          </div>
          <label>
            <input v-model.trim="userInformation.address" type="text" />
          </label>
        </v-col>

        <v-col cols="12">
          <div>
            <v-btn @click="changeUserInfo" outlined color="#3f57bb"
              >{{ $i18n.t("personal.submit") }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <div>
            {{
              $i18n.t(
                "personal.The content with * is required, and perfect information is easier to pass the audit"
              )
            }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PersonalInformation",
  data() {
    return {
      userInformation: {
        telephone: "",
        name: "",
        company: "",
        jobTitle: "",
        address: "",
        groupName: "",
      },
    };
  },
  mounted() {
    let token = this.$route.query.token;
    if (token) {
      window.sessionStorage.setItem("accessToken", JSON.stringify(token));
      this.activeAccount().then(() => {});
    }
  },
  methods: {
    ...mapActions(["changeUserInformation", "activeAccount"]),
    changeUserInfo() {
      this.changeUserInformation(this.userInformation)
        .then(() => {
          window.sessionStorage.removeItem("accessToken");
          this.$router.push("/");
        })
        .catch(() => {
          window.sessionStorage.removeItem("accessToken");
        });
    },
  },
};
</script>

<style scoped>
input {
  width: 260px;
  height: 36px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(231, 231, 231, 1);
  padding-left: 10px;
}
</style>
